import { IoMdCloseCircle } from "react-icons/io";
import { ClipLoader } from "react-spinners";

const ConfirmationModal = ({
  isOpen,
  setIsOpen,
  isLoading,
  actionId,
  onConfirm,
  title = "¿Estás seguro?", // Título personalizable
  description = "Esta acción no se puede deshacer.", // Descripción personalizable
  confirmText = "Confirmar", // Texto del botón de confirmar
  cancelText = "Cancelar", // Texto del botón de cancelar
}) => {
  return (
    <div
      className={`fixed inset-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50 
      ${isOpen ? "visible" : "invisible"}`}
    >
      <div
        className={`w-[400px] bg-white p-6 rounded-lg shadow-lg transition-transform duration-300 
        ${isOpen ? "scale-100" : "scale-90"}`}
      >
        {/* Header */}
        <div className="flex justify-between items-start mb-4">
          <h2 className="text-gray-800 font-bold text-lg">{title}</h2>
          <IoMdCloseCircle
            onClick={() => setIsOpen(false)}
            className="text-gray-500 cursor-pointer text-2xl hover:text-gray-700"
          />
        </div>
        {/* Descripción */}
        <p className="text-gray-600 mb-6 text-sm">{description}</p>
        {/* Botones */}
        <div className="flex justify-end gap-3">
          <button
            onClick={() => setIsOpen(false)}
            className="px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-700 rounded-md"
          >
            {cancelText}
          </button>
          <button
            onClick={() => {
              if (!isLoading) {
                onConfirm(actionId);
                setIsOpen(false);
              }
            }}
            disabled={isLoading}
            className={`px-4 py-2 rounded-md text-white flex items-center justify-center 
            ${isLoading ? "bg-blue-400" : "bg-blue-600 hover:bg-blue-700"}`}
          >
            {isLoading ? <ClipLoader size={18} color="#fff" /> : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
